import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as C } from "./index.es2444.js";
function d(n) {
  const { outline: i, fill: t, size: l } = C(n);
  return /* @__PURE__ */ o(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M2 0C1.44772 0 1 0.447715 1 1V6H7C7 4.89543 7.89543 4 9 4C10.1046 4 11 4.89543 11 6H17V1C17 0.447715 16.5523 0 16 0H2Z",
            fill: t
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.44237 12.6746L15.5346 17.1244C15.8319 17.3416 16.25 17.1292 16.25 16.761V1.00012C16.25 0.862051 16.1381 0.750122 16 0.750122H2C1.86193 0.750122 1.75 0.862051 1.75 1.00012V16.761C1.75 17.1292 2.16809 17.3416 2.46542 17.1244L8.55763 12.6746C8.82114 12.4822 9.17886 12.4822 9.44237 12.6746ZM15.0922 17.7301C15.8851 18.3092 17 17.7429 17 16.761V1.00012C17 0.447838 16.5523 0.00012207 16 0.00012207H2C1.44771 0.00012207 1 0.447838 1 1.00012V16.761C1 17.7429 2.1149 18.3092 2.90779 17.7301L9 13.2803L15.0922 17.7301Z",
            fill: i
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 4.375C8.10254 4.375 7.375 5.10254 7.375 6C7.375 6.89747 8.10254 7.625 9 7.625C9.89746 7.625 10.625 6.89747 10.625 6C10.625 5.10254 9.89746 4.375 9 4.375ZM6.625 6C6.625 4.68833 7.68832 3.625 9 3.625C10.3117 3.625 11.375 4.68833 11.375 6C11.375 7.31168 10.3117 8.375 9 8.375C7.68832 8.375 6.625 7.31168 6.625 6Z",
            fill: i
          }
        )
      ]
    }
  );
}
d.__tags = [];
export {
  d as TagIcon
};
//# sourceMappingURL=index.es365.js.map
